import { defineComponent as _defineComponent } from 'vue'
import bugsnagClient from 'JS/global/bugsnag';
import NewBlogCarousel from 'JS/components/carousels/NewBlogCarousel.vue';
import Spinner from 'JS/components/Spinner.vue';
import VIntersectionObserver from 'JS/components/VIntersectionObserver.vue';
import { BlogCarouselWidgetData } from 'JS/dxp/types/widgets/blog-carousel-widget';
import { BlogService, CarouselQuery, PostQuery } from 'JS/services/BlogService';
import { inject, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AsyncBlogCarousel',
  props: {
    heading: null,
    query: null,
    viewAllLink: null
  },
  setup(__props: any) {

const props = __props as {
	heading: string;
	query: CarouselQuery; // Use when loading async
	viewAllLink?: string;
}

const loadingState = ref<'loading' | 'error' | 'done'>('loading');
const blogService = inject('BlogService', () => new BlogService(), true);



const carouselData = ref<BlogCarouselWidgetData | null>(null);

async function handleVisible() {

	const query: CarouselQuery = props.query;

	try {
		carouselData.value = await blogService.getCarouselData(query);
		loadingState.value = 'done';
	} catch (e) {
		loadingState.value = 'error';
		bugsnagClient.notify(e, {
			metaData: {
				info: "failed to retrieve blog carousel data"
			}
		});
	}
}

const handleHidden = () => {
	// TODO: Should we do anything while hidden?
};

return { __sfc: true,loadingState, blogService, props, carouselData, handleVisible, handleHidden, NewBlogCarousel, VIntersectionObserver }
}

})